var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/device-tablet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17 25.5H17.0142M9.91668 29.75H24.0833C25.6481 29.75 26.9167 28.4815 26.9167 26.9167V7.08333C26.9167 5.51853 25.6481 4.25 24.0833 4.25H9.91668C8.35187 4.25 7.08334 5.51853 7.08334 7.08333V26.9167C7.08334 28.4815 8.35187 29.75 9.91668 29.75Z",
    stroke: "#4FC0CF",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceTablet);
export default __webpack_public_path__ + "static/media/device-tablet.54d8fc3e656e43754fba66da35c2c431.svg";
export { ForwardRef as ReactComponent };